import { render, staticRenderFns } from "./ProfitRule.vue?vue&type=template&id=38ee0ff8&scoped=true&"
import script from "./ProfitRule.vue?vue&type=script&lang=js&"
export * from "./ProfitRule.vue?vue&type=script&lang=js&"
import style0 from "./ProfitRule.vue?vue&type=style&index=0&id=38ee0ff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ee0ff8",
  null
  
)

export default component.exports